<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addCourt">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <!--列表-->
    <el-table :height="'calc(100% - 70px)'" :data="courtList" class="button-box">
      <el-table-column label="球场名称" prop="name"></el-table-column>
      <el-table-column label="手机号" prop="phone"></el-table-column>
      <el-table-column label="开业年份" prop="year"></el-table-column>
      <el-table-column label="设计师" prop="designer"></el-table-column>
      <el-table-column label="孔数" prop="holesNumber"></el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="是否启用" prop="enumEnable">
        <template slot-scope="scope">
          {{scope.row.enumEnable === 'NORMAL' ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button icon="el-icon-edit" @click="lookCourt(scope.row)">查看</el-button></div>
              <div><el-button @click="editCourt(scope.row)">修改</el-button></div>
              <div><el-button icon="el-icon-delete" @click="removeCourtById(scope.row.id)">删除</el-button></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getCourtList" /></div>

  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import { getPostOrDeleteData } from '@/utils/code'
import { deleteCourt, getCourtList } from '@/api/court/court'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput, Pagination },
  data() {
    return {
      // 查询参数
      queryInfo: {
        keyword: ''
      },
      courtList: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    //查询列表
    getCourtList(page, cb) {
      getCourtList(page).then((response) => {
        this.courtList = cb(response)
      })
    },

    //根据ID删除数据
    removeCourtById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCourt(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }).catch(() => {
      })
    },

    //新增
    addCourt() {
      this.$router.push({
        path: '/addCourt'
      })
    },

    //修改
    editCourt(row) {
      this.$router.push({
        path: '/editCourt',
        query: {
          id: row.id
        }
      })
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //查看详情
    lookCourt(row) {
      this.$router.push({
        path: '/viewDetails',
        query: {
          id: row.id
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>

</style>
